import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-fa_order",
  "use": "icon-fa_order-usage",
  "viewBox": "220 230 520 520",
  "content": "<symbol viewBox=\"220 230 520 520\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-fa_order\">\r\n  <path d=\"M240 500L480 660L720 500V690C720 712.091 702.091 730 680 730H280C257.909 730 240 712.091 240 690V500ZM300 480V290C300 267.909 317.909 250 340 250H620C642.091 250 660 267.909 660 290V480M360 340H420V400H360ZM360 430H420V490H360ZM360 520H420V580H360ZM460 360H600M460 430H600M460 520H560\" stroke=\"#555970\" stroke-width=\"24\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/fa_order.svg
// module id = yGlC
// module chunks = 63